import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { service_insurance } from "../../../data/servicesData";
import HomeTabPage from "../InsuranceTab/HomeTabPage";
import CarTabPage from "../InsuranceTab/CarTabPage";
import LandlordsTabPage from "../InsuranceTab/LandlordsTabPage";
import HealthTabPage from "../InsuranceTab/HealthTabPage";
import BusinessPackTabPage from "../InsuranceTab/BusinessPackTabPage";
import PublicLiabilityTabPage from "../InsuranceTab/PublicLiabilityTabPage";
import CyberTabPage from "../InsuranceTab/CyberTabPage";
import ProfessionalTabPage from "../InsuranceTab/ProfessionalTabPage";

const InsuranceTabComponent = () => {
  //use for tab handle
  const [value, setValue] = useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const tabStyle = {
    color: "#555",
    minWidth: 120,
    whiteSpace: "nowrap",
    "&.Mui-selected": {
      color: "#F7C332",
    },
  };

  return (
    <div>
      <Box
        sx={{
          width: "100%",
          maxWidth: "90vw", // default for all
          overflowX: "hidden",
          // media queries below

          "@media (min-width:640px)": {
            px: "3vw", // sm and up
          },
          "@media (min-width:1280px)": {
            px: "0vw", // xl and up
          },
        }}
      >
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="insurance tabs"
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#F7C332",
                },
              }}
            >
              <Tab
                label={service_insurance.tab_item_1}
                value="1"
                sx={tabStyle}
              />
              <Tab
                label={service_insurance.tab_item_2}
                value="2"
                sx={tabStyle}
              />
              <Tab
                label={service_insurance.tab_item_3}
                value="3"
                sx={tabStyle}
              />
              <Tab
                label={service_insurance.tab_item_4}
                value="4"
                sx={tabStyle}
              />
              <Tab
                label={service_insurance.tab_item_5}
                value="5"
                sx={tabStyle}
              />
              <Tab
                label={service_insurance.tab_item_6}
                value="6"
                sx={tabStyle}
              />
              <Tab
                label={service_insurance.tab_item_7}
                value="7"
                sx={tabStyle}
              />
              <Tab
                label={service_insurance.tab_item_8}
                value="8"
                sx={tabStyle}
              />
            </TabList>
          </Box>
          <TabPanel value="1">
            <HomeTabPage />
          </TabPanel>
          <TabPanel value="2">
            <CarTabPage />
          </TabPanel>
          <TabPanel value="3">
            <LandlordsTabPage />
          </TabPanel>
          <TabPanel value="4">
            <HealthTabPage />
          </TabPanel>
          <TabPanel value="5">
            <BusinessPackTabPage />
          </TabPanel>
          <TabPanel value="6">
            <PublicLiabilityTabPage />
          </TabPanel>
          <TabPanel value="7">
            <CyberTabPage />
          </TabPanel>
          <TabPanel value="8">
            <ProfessionalTabPage />
          </TabPanel>
        </TabContext>
      </Box>
    </div>
  );
};

export default InsuranceTabComponent;
